<template>
  <div>
    <div class="login-block">
      <LoadingSpinner v-if="cargando" />
      <div class="row">
        <div class="container container-login">
          <div class="row">
            <div class="col-md-4 login-sec">
              <h2 class="text-center">
                <img
                  src="/img/Logo-Hemolife.png"
                  alt="Logo Hemolife"
                  style="width: 160px"
                />
              </h2>
              <h1 class="text-center platform-title">Hemotrack</h1>
              <div class="text-center">
                <span
                  class="font-weight-bold text-center"
                  style="font-size: 16px"
                >
                  <b>Fundación Banco Nacional de Sangre </b>
                </span>
              </div>
              <hr />
              <form @submit.prevent="login">
                <div class="input-group mb-3">
                  <input
                    type="email"
                    class="form-control"
                    v-model="form.email"
                    placeholder="Email"
                    :class="$v.form.email.$invalid ? 'is-invalid' : 'is-valid'"
                    autocomplete="off"
                  />
                  <div class="input-group-append">
                    <div class="input-group-text">
                      <span class="fas fa-envelope"></span>
                    </div>
                  </div>
                </div>
                <div class="input-group mb-3">
                  <input
                    :type="showPassword ? 'text' : 'password'"
                    class="form-control"
                    v-model="form.password"
                    placeholder="Password"
                    :class="
                      $v.form.password.$invalid ? 'is-invalid' : 'is-valid'
                    "
                    autocomplete="off"
                  />
                  <span
                    class="password-toggle-icon"
                    v-if="form.password"
                    @click="togglePasswordVisibility"
                  >
                    <i
                      :class="showPassword ? 'fas fa-eye-slash' : 'fas fa-eye'"
                    ></i>
                  </span>
                  <div class="input-group-append">
                    <div class="input-group-text">
                      <span class="fas fa-lock"></span>
                    </div>
                  </div>
                </div>
                <div class="form-check">
                  <label class="form-check-label">
                    <input type="checkbox" class="form-check-input" />
                    <small>Recordarme</small>
                  </label>
                  <button
                    type="submit"
                    class="btn btn-login float-right"
                    v-show="!$v.form.$invalid"
                  >
                    Ingresar
                  </button>
                </div>

                <div class="login-links mb-3">
                  <router-link to="/ForgotPassword">
                    Deseo recordar mi contraseña
                  </router-link>
                  <router-link to="/Registro" class="btn btn-register">
                    Registrarse
                  </router-link>
                </div>
              </form>
            </div>
            <div class="col-md-8 banner-sec">
              <div
                id="carouselExampleIndicators"
                class="carousel slide"
                data-ride="carousel"
              >
                <ol class="carousel-indicators">
                  <li
                    data-target="#carouselExampleIndicators"
                    data-slide-to="0"
                    class="active"
                  ></li>
                  <li
                    data-target="#carouselExampleIndicators"
                    data-slide-to="1"
                  ></li>
                  <li
                    data-target="#carouselExampleIndicators"
                    data-slide-to="2"
                  ></li>
                  <li
                    data-target="#carouselExampleIndicators"
                    data-slide-to="3"
                  ></li>
                  <li
                    data-target="#carouselExampleIndicators"
                    data-slide-to="4"
                  ></li>
                </ol>
                <div class="carousel-inner" role="listbox">
                  <div class="carousel-item active">
                    <img
                      class="d-block banner-carousel-img"
                      src="/img/fondos/DSC02202.jpg"
                      alt="First slide"
                    />
                    <div class="carousel-caption d-none d-md-block">
                      <div class="banner-text">
                        <h2>Nuestro Equipo</h2>
                      </div>
                    </div>
                  </div>
                  <div class="carousel-item">
                    <img
                      class="d-block banner-carousel-img"
                      src="/img/fondos/IMG_2483.jpg"
                      alt="Second slide"
                    />
                    <div class="carousel-caption d-none d-md-block">
                      <div class="banner-text">
                        <h2>Oficina Principal</h2>
                      </div>
                    </div>
                  </div>
                  <div class="carousel-item">
                    <img
                      class="d-block banner-carousel-img"
                      src="/img/fondos/vehículos.jpg"
                      alt="Third slide"
                    />
                    <div class="carousel-caption d-none d-md-block">
                      <div class="banner-text">
                        <h2>Nuestros Vehículos</h2>
                      </div>
                    </div>
                  </div>
                  <div class="carousel-item">
                    <img
                      class="d-block banner-carousel-img"
                      src="/img/fondos/IMG_2634.jpg"
                      alt="Fourth slide"
                    />
                    <div class="carousel-caption d-none d-md-block">
                      <div class="banner-text">
                        <h2>Laboratorios</h2>
                      </div>
                    </div>
                  </div>
                  <div class="carousel-item">
                    <img
                      class="d-block banner-carousel-img"
                      src="/img/fondos/baja.jpg"
                      alt="first slide"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { required, email } from "vuelidate/lib/validators";
import LoadingSpinner from "../components/LoadingSpinner";

export default {
  components: {
    LoadingSpinner,
  },
  name: "LoginForm",
  data: () => ({
    user: {},
    form: {
      email: "",
      password: "",
    },
    showPassword: false,
    cargando: false,
  }),

  validations: {
    form: {
      email: {
        required,
        email,
      },
      password: {
        required,
      },
    },
  },

  methods: {
    async login() {
      this.cargando = true;
      await this.$store.dispatch("login", this.form);
      if (this.$store.getters.isAuthenticated) {
        this.cargando = false;
        // `cliente` es null para los usuarios internos (no asociados a un
        // cliente), que son la mayoria. Sin el encadenamiento opcional esta
        // linea lanza TypeError y aborta el metodo antes de navegar: la sesion
        // queda abierta pero el usuario se queda viendo el formulario.
        const empresaEstado = this.$store.getters.getUser.cliente?.estado;
        if (empresaEstado === 2) {
          this.$swal({
            icon: "error",
            title: "Oops...",
            text: "La empresa se encuentra bloqueada o inactiva.",
          });
          await this.$store.dispatch("logout");
          // No se navega: ya estamos en el formulario de login. Antes iba a
          // "/login", ruta que no existe en el router (el login es /LoginForm).
          return;
        }

        return this.$router.replace("/");
      } else {
        this.cargando = false;
        if (this.$store.getters.getErrors == "password_updated_at") {
          this.$swal({
            icon: "error",
            title: "Oops...",
            text: "Ha pasado mucho tiempo sin actualizar la contraseña, por favor cámbiela!",
          });
          this.$store.commit("SET_ERRORS", null);
          return this.$router.push({
            name: "ResetPassword",
            params: {
              token: "token",
              email: this.form.email,
            },
          });
        } else if (this.$store.getters.getErrors === "recaptcha") {
          this.$swal({
            icon: "error",
            title: "Oops...",
            text: "Lo sentimos, pero las credenciales que has proporcionado son incorrectas. Por favor, verifica la información ingresada e inténtalo nuevamente.",
          });
        } else if (this.$store.getters.getErrors === "status") {
          this.$swal({
            icon: "error",
            title: "Oops...",
            text: "Lo sentimos, pero las credenciales que has proporcionado son incorrectas. Por favor, verifica la información ingresada e inténtalo nuevamente.",
          });
        } else if (this.$store.getters.getErrors === "email") {
          this.$swal({
            icon: "error",
            title: "Oops...",
            text: this.$store.getters.getMensajeLogin,
          });
        } else {
          this.$swal({
            icon: "error",
            title: "Oops...",
            text: "Lo sentimos, pero las credenciales que has proporcionado son incorrectas. Por favor, verifica la información ingresada e inténtalo nuevamente.",
          });
        }
      }
    },

    togglePasswordVisibility() {
      this.showPassword = !this.showPassword;
    },
  },

  created() {
    if (this.$store.getters.isAuthenticated) {
      return this.$router.replace("/");
    }
  },
};
</script>

<style>
.login-block {
  background:
    radial-gradient(circle at top right, rgba(229, 53, 56, 0.3), transparent 48%),
    radial-gradient(circle at bottom left, rgba(78, 105, 144, 0.25), transparent 52%),
    linear-gradient(135deg, #f8fbff, #fff4f4);
  width: 100%;
  min-height: 100vh;
  padding: 32px 16px;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
}

.container-login {
  background: rgba(255, 255, 255, 0.94);
  border-radius: 24px;
  box-shadow: 0 24px 52px rgba(16, 24, 40, 0.14);
  border: 1px solid rgba(229, 53, 56, 0.1);
  max-width: 1025px;
  overflow: hidden;
}

.carousel-caption {
  text-align: left;
  left: 5%;
}

.banner-text {
  width: 70%;
  position: absolute;
  bottom: 40px;
  padding-left: 20px;
}
.banner-text h2 {
  color: #fff;
  font-weight: 800;
  text-shadow: 0 2px 8px rgba(0, 0, 0, 0.35);
}
.banner-text h2:after {
  content: " ";
  width: 80px;
  height: 5px;
  background: #fff;
  display: block;
  margin-top: 20px;
  border-radius: 3px;
}
.banner-text p {
  color: #fff;
}

/*
 * La columna del login suele ser más alta que 460px: Bootstrap iguala altura de columnas
 * y el carrusel quedaba corto → franja blanca abajo.
 * Rellenamos solo el contenedor .banner-sec (sin flex en .carousel-inner, compatible con Bootstrap).
 */
.container-login > .row {
  align-items: stretch;
}

.container-login > .row > .col-md-8 {
  position: relative;
  min-height: 460px;
}

.banner-sec {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  border-radius: 0 24px 24px 0;
  padding: 0;
  overflow: hidden;
}

.banner-sec .carousel,
.banner-sec .carousel-inner {
  height: 100%;
}

.banner-sec .carousel-inner {
  border-radius: 0 24px 24px 0;
}

.banner-sec .carousel-item {
  height: 100%;
}

.banner-sec .banner-carousel-img {
  display: block;
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center;
  filter: brightness(0.82);
}

.banner-text {
  background: linear-gradient(
    90deg,
    rgba(0, 0, 0, 0.58) 0%,
    rgba(0, 0, 0, 0.2) 80%,
    rgba(0, 0, 0, 0) 100%
  );
  border-radius: 12px;
  padding: 14px 16px;
}

.login-sec {
  padding: 48px 34px 24px;
  background: #ffffff;
  position: relative;
  border-right: 1px solid rgba(78, 105, 144, 0.08);
}
.login-sec .copy-text {
  position: absolute;
  width: 80%;
  bottom: 20px;
  font-size: 13px;
  text-align: center;
}
.login-sec .copy-text i {
  color: #e53538;
}
.login-sec .copy-text a {
  color: #4e6990;
}
.login-sec h2 {
  margin-bottom: 8px;
  font-weight: 700;
}

.platform-title {
  font-size: 15px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 2.4px;
  margin-top: 12px;
  background: linear-gradient(135deg, #4e6990, #e53538);
  -webkit-background-clip: text;
  background-clip: text;
  color: transparent;
}

.login-sec h2:after {
  margin-top: 10px;
  content: " ";
  width: 180px;
  height: 4px;
  background: radial-gradient(closest-side, #4e6990, #e53538);
  display: block;
  border-radius: 10px;
  margin-left: auto;
  margin-right: auto;
}

.login-sec hr {
  border-color: rgba(78, 105, 144, 0.14);
  margin: 18px 0 20px;
}

.login-sec .font-weight-bold {
  color: #4f5f78;
  font-size: 14px !important;
}

.btn-login {
  background: linear-gradient(135deg, #e53538, #c92224);
  color: #fff;
  font-weight: 600;
  border-radius: 12px;
  min-width: 120px;
  box-shadow: 0 10px 22px rgba(229, 53, 56, 0.28);
  border: none;
  transition: all 0.2s ease;
}

.btn-login:hover {
  transform: translateY(-1px);
  box-shadow: 0 12px 24px rgba(229, 53, 56, 0.35);
  color: #fff;
}

.login-sec .form-check {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 18px;
}

.login-sec .form-check-label {
  color: #5f6d82;
  font-weight: 500;
}

.login-sec .form-check-input {
  margin-top: 0.2rem;
}

.login-block .input-group {
  position: relative;
}

.password-toggle-icon {
  position: absolute;
  right: 66px;
  top: 50%;
  transform: translateY(-50%);
  cursor: pointer;
  color: #6f7d92;
  z-index: 2;
  font-size: 15px;
  transition: color 0.2s ease;
}

.password-toggle-icon:hover {
  color: #4e6990;
}

.login-block .form-control {
  border-radius: 12px 0 0 12px;
  border: 1px solid #d6dce8;
  background: #fbfcff;
  min-height: 44px;
  padding-right: 54px;
}

.login-block .input-group-text {
  border-radius: 0 12px 12px 0;
  border: 1px solid #d6dce8;
  border-left: none;
  background: #f1f4fa;
  color: #4e6990;
}

.login-block .form-control:focus {
  border-color: #4e6990;
  box-shadow: 0 0 0 3px rgba(78, 105, 144, 0.15);
}

.login-block a {
  color: #4e6990;
  font-weight: 600;
  text-decoration: none;
}

.login-block a:hover {
  color: #e53538;
  text-decoration: underline;
}

.login-links {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 14px;
}

.login-links .btn-register {
  border: 1px solid #4e6990;
  border-radius: 10px;
  color: #4e6990;
  font-size: 0.88rem;
  padding: 7px 14px;
  white-space: nowrap;
}

.login-links .btn-register:hover {
  background: #4e6990;
  color: #fff;
  text-decoration: none;
}

@media (max-width: 991.98px) {
  .banner-sec {
    display: none;
  }

  .container-login > .row > .col-md-8 {
    position: static;
    min-height: 0;
  }

  .login-sec {
    border-right: none;
    padding: 36px 24px;
  }

  .container-login {
    max-width: 520px;
  }
}

@media (max-width: 575.98px) {
  .login-block {
    padding: 20px 12px;
  }

  .login-sec {
    padding: 28px 18px;
  }

  .login-sec .form-check {
    flex-direction: column;
    align-items: flex-start;
    gap: 10px;
  }

  .btn-login {
    width: 100%;
  }

  .login-links {
    align-items: stretch;
    flex-direction: column;
  }

  .login-links .btn-register {
    text-align: center;
  }
}
</style>

